/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CompanyEvent } from '../model';
/**
 * CompanyEventsApi - axios parameter creator
 * @export
 */
export const CompanyEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsCancelCreate: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling companyEventsCancelCreate.');
            }
            const localVarPath = `/api/company_events/{id}/cancel/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent'} [eventType] event_type
         * @param {'pending' | 'done' | 'cancel' | 'expired'} [registerStatus] register_status
         * @param {string} [requestCompanyId] request_company_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsList: async (eventType?: 'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent', registerStatus?: 'pending' | 'done' | 'cancel' | 'expired', requestCompanyId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company_events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (registerStatus !== undefined) {
                localVarQueryParameter['register_status'] = registerStatus;
            }

            if (requestCompanyId !== undefined) {
                localVarQueryParameter['request_company_id'] = requestCompanyId;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsRetrieve: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling companyEventsRetrieve.');
            }
            const localVarPath = `/api/company_events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyEventsApi - functional programming interface
 * @export
 */
export const CompanyEventsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyEventsCancelCreate(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CompanyEventsApiAxiosParamCreator(configuration).companyEventsCancelCreate(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent'} [eventType] event_type
         * @param {'pending' | 'done' | 'cancel' | 'expired'} [registerStatus] register_status
         * @param {string} [requestCompanyId] request_company_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyEventsList(eventType?: 'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent', registerStatus?: 'pending' | 'done' | 'cancel' | 'expired', requestCompanyId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyEvent>>> {
            const localVarAxiosArgs = await CompanyEventsApiAxiosParamCreator(configuration).companyEventsList(eventType, registerStatus, requestCompanyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyEventsRetrieve(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyEvent>> {
            const localVarAxiosArgs = await CompanyEventsApiAxiosParamCreator(configuration).companyEventsRetrieve(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompanyEventsApi - factory interface
 * @export
 */
export const CompanyEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsCancelCreate(id: string, options?: any): AxiosPromise<void> {
            return CompanyEventsApiFp(configuration).companyEventsCancelCreate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent'} [eventType] event_type
         * @param {'pending' | 'done' | 'cancel' | 'expired'} [registerStatus] register_status
         * @param {string} [requestCompanyId] request_company_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsList(eventType?: 'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent', registerStatus?: 'pending' | 'done' | 'cancel' | 'expired', requestCompanyId?: string, options?: any): AxiosPromise<Array<CompanyEvent>> {
            return CompanyEventsApiFp(configuration).companyEventsList(eventType, registerStatus, requestCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this company event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEventsRetrieve(id: string, options?: any): AxiosPromise<CompanyEvent> {
            return CompanyEventsApiFp(configuration).companyEventsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyEventsApi - object-oriented interface
 * @export
 * @class CompanyEventsApi
 * @extends {BaseAPI}
 */
export class CompanyEventsApi extends BaseAPI {
    /**
     * 
     * @param {string} id A UUID string identifying this company event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyEventsApi
     */
    public companyEventsCancelCreate(id: string, options?: any) {
        return CompanyEventsApiFp(this.configuration).companyEventsCancelCreate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent'} [eventType] event_type
     * @param {'pending' | 'done' | 'cancel' | 'expired'} [registerStatus] register_status
     * @param {string} [requestCompanyId] request_company_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyEventsApi
     */
    public companyEventsList(eventType?: 'register_client_company' | 'register_client_user' | 'register_agent_company_payer_client' | 'register_agent_company_payer_agent' | 'register_agent_user' | 'change_payer_to_client' | 'change_payer_to_agent', registerStatus?: 'pending' | 'done' | 'cancel' | 'expired', requestCompanyId?: string, options?: any) {
        return CompanyEventsApiFp(this.configuration).companyEventsList(eventType, registerStatus, requestCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this company event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyEventsApi
     */
    public companyEventsRetrieve(id: string, options?: any) {
        return CompanyEventsApiFp(this.configuration).companyEventsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}
